import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ArtifactReviewStatus, ArtifactSummary } from '../../forgeApi.types'

interface GetReviewQueueResponse {
  artifacts?: ArtifactSummary[]
}

// Widgets in the reviewer's own org matching `status` (default: awaiting review).
// Reviewer-only server-side — a non-reviewer gets 403.
const getReviewQueue = async (
  status: ArtifactReviewStatus = 'pending'
): Promise<ArtifactSummary[]> => {
  const response = await forgeApi.get<GetReviewQueueResponse>(
    '/api/v1/artifacts/reviews',
    { params: { status } }
  )
  return response.data.artifacts ?? []
}

export const REVIEW_QUEUE_QUERY_KEY = 'forge-review-queue'

export const useReviewQueueQuery = (
  status: ArtifactReviewStatus = 'pending',
  options?: ExtendableQueryOptions<ArtifactSummary[]>
) =>
  useQuery({
    queryKey: [REVIEW_QUEUE_QUERY_KEY, status],
    queryFn: () => getReviewQueue(status),
    ...options
  })
